import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';

@Injectable({
    providedIn: 'root'
})
export class ProjectGalleryService {

    constructor(private apiService: ApiBaseService) { }

    getProjectImageGallery(payload: any): Promise<any> {
        return this.apiService.httpRequest('ProjectGalleryService/GetProjectImageGallery', payload, true, true);
    }

    addProjectImage(payload: any): Promise<any> {
        return this.apiService.httpRequestForm('ProjectGalleryService/AddProjectImage', payload, true, true)
    }

    getProjectGalleryImage(payload: any): Promise<any> {
        return this.apiService.httpRequest('ProjectGalleryService/GetProjectGalleryImage', payload, true, false);
    }

    addProjectGalleryFolder(payload: any): Promise<any> {
        return this.apiService.httpRequest('ProjectGalleryService/AddProjectGalleryFolder', payload, true, true);
    }

    editProjectGalleryFolder(payload: any): Promise<any> {
        return this.apiService.httpRequest('ProjectGalleryService/EditProjectGalleryFolder', payload, true, true);
    }

    deleteFolderProjectGallery(payload: any): Promise<any> {
        return this.apiService.httpRequest('ProjectGalleryService/DeleteFolderProjectGallery', payload, true, true);
    }

    deleteFileProjectGallery(payload: any): Promise<any> {
        return this.apiService.httpRequest('ProjectGalleryService/DeleteFileProjectGallery', payload, true, true);
    }

    moveProjectFolderGallery(payload: any): Promise<any> {
        return this.apiService.httpRequest('ProjectGalleryService/MoveFolderProjectGallery', payload, true, true);
    }

    moveProjectFileGallery(payload: any): Promise<any> {
        return this.apiService.httpRequest('ProjectGalleryService/MoveFileProjectGallery', payload, true, true);
    }





}
